<img [src]="imgUrl"
    [ngStyle]="{'width': width}"
    (mouseenter)="onEnter($event)"
    (mouseleave)="onLeave($event)"
    (error)="onError($event)">